<template>
  <v-container fluid class="user-list">

    <v-row class="ma-0">
       <v-card width="100%" class="ma-1">
         <v-card-text>
           <v-row no-gutters class="d-flex" justify="space-between">
             <v-col cols="12" md="3">
               <v-card-title>{{ languageData.usersList }}</v-card-title>
             </v-col>
             <v-col cols="12" md="3" class="mt-3">
               <div>
                 <v-text-field
                     dense
                     :full-width="$vuetify.breakpoint.smAndDown"
                     outlined
                     hide-details
                     @keyup="filtersUsers(true)"
                     v-model="searchUser"
                     :placeholder="languageData.search"
                     :label="languageData.search"
                     prepend-inner-icon="mdi-magnify"></v-text-field>
               </div>
             </v-col>
             <v-col cols="12" md="3" class="mt-3" v-if="languageData.subscriptionStatus">
               <div>
                 <v-select
                     dense
                     outlined
                     :label="languageData.isSubscribing"
                     :items="subscriptionStatus"
                     :full-width="$vuetify.breakpoint.smAndDown"
                     @change="filtersUsers(false)"
                     v-model="filterUser"
                     item-value="value"
                     item-text="name">
                   <template slot='selection' slot-scope='{ item }'>
                     {{ languageData.subscriptionStatus[item.value] }}
                   </template>
                   <template slot='item' slot-scope='{ item }'>
                     {{ languageData.subscriptionStatus[item.value] }}
                   </template>
                 </v-select>
               </div>
             </v-col>
           </v-row>
         </v-card-text>
       </v-card>
     </v-row>
     <v-row class="ma-0">
       <v-card width="100%" class="ma-1">
         <v-card-text>
           <v-data-table
               loading-text="Loading... Please wait"
               class="users-table"
               :search="searchUser"
               :headers="headers"
               :loading="loadingUsers"
               :options.sync="pagination"
               :server-items-length="totalItems"
               :items-per-page-options="rowsPerPageItems"
               :footer-props="footerOptions"
               :page.sync="currentPage"
               :items="dataReceive">
             <template v-slot:item.subscription="{ item }">
               <td>
                 <template v-if="item.subscription.isSubscribing">
                   <v-icon color="success">
                     mdi-check-circle
                   </v-icon>
                 </template>
                 <template v-else>
                   <v-icon color="grey lighten-1">
                     mdi-check-circle
                   </v-icon>
                 </template>
                 <template v-if="item.subscription.isFreeTrial">
                   {{ languageData.trial }}
                 </template>
                 <template v-else>
                   {{ languageData.subscription }}
                 </template>
                 <template>
                   <span class="blue-grey--text lighten-1">/</span>
                   {{ item.subscription.validUntil }}
                 </template>
               </td>
             </template>
           </v-data-table>
         </v-card-text>
       </v-card>
     </v-row>
  </v-container>
</template>

<script type="text/javascript">
  import {mapActions, mapState} from "vuex";
  import eventBus from "../../../../event-bus/eventBus";
  import subscriptionStatus from "../../../../enums/subscriptionStatus";

  export default {
    name: "ListUsers",
    components: {},
    data() {
      return {
        searchUser: null,
        filterUser: 0,
        subscriptionStatus: subscriptionStatus,
        footerOptions: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPage: 1,
        modalSaveInfoData: {},
        isShowSaveModalInfo: false,
        searchTask: null,
        searchDebouceTime: 500
      }
    },
    computed: {
      ...mapState("getUsers", {
        dataReceive: state => state.dataReceive,
        headers: state => state.headers,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        sortBy: state => state.pagination.sortBy,
        loadingUsers: state => state.loadingUsers
      }),
      pagination: {
        set: function(value) {
          this.searchUsers(value);
        },
        get: function() {
          return this.$store.state.getUsers.pagination;
        }
      }
    },
    methods: {
      filtersUsers: function(debounce) {
        if(debounce) {
          clearTimeout(this.searchTask);
          this.searchTask = setTimeout(() => {this.searchUsers({}, true)}, this.searchDebouceTime);
        } else {
          this.searchUsers({}, true);
        }

      },
      searchUsers: function(valueSearch={}, filters=false) {
          valueSearch.language = this.getCurrentLanguage;
          valueSearch.filters = filters;
          valueSearch.search = this.searchUser;
          valueSearch.status = this.filterUser;
          if(valueSearch.status === 0) {
            delete valueSearch.status;
          }
          this.getUsers({valueSearch});
          if(filters) {
            this.currentPage = 1;
          }
      },
      getFirstLetter: function(firstname) {
        return firstname.charAt(0);
      },
      ...mapActions("getUsers", ["getUsers", "getHeadersTable"]),
    },
    mounted() {
      const language = this.getCurrentLanguage;
      this.getHeadersTable({creds: {language}});
      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersTable({creds: {language}});
      });
      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      });
    }
  }
</script>